import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Clock, ChevronRight } from 'lucide-react';

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-muted border-t border-border relative z-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div>
            <h3 className="font-orbit text-base sm:text-lg font-bold mb-3 sm:mb-4 text-foreground">Kontakt oss</h3>
            <div className="flex flex-col space-y-3 sm:space-y-4">
              <div className="flex items-start">
                <Mail className="h-4 w-4 sm:h-5 sm:w-5 text-primary mr-2 sm:mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-sm sm:text-base text-muted-foreground">kundeservice@peveo.no</span>
              </div>
              <div className="flex items-start">
                <Phone className="h-4 w-4 sm:h-5 sm:w-5 text-primary mr-2 sm:mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-sm sm:text-base text-muted-foreground">+47 908 01 617</span>
              </div>
              <div className="flex items-start">
                <Clock className="h-4 w-4 sm:h-5 sm:w-5 text-primary mr-2 sm:mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="block text-sm sm:text-base text-muted-foreground">Man - Fre: 08:00 - 16:00</span>
                  <span className="block text-sm sm:text-base text-muted-foreground">Lør - Søn: Stengt</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-orbit text-base sm:text-lg font-bold mb-3 sm:mb-4 text-foreground">Produkter</h3>
            <nav className="flex flex-col space-y-1.5 sm:space-y-2">
              <Link to="/products/pre-workout" className="text-sm sm:text-base text-muted-foreground hover:text-primary flex items-center transition-colors" onClick={handleLinkClick}>
                <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4 mr-1" />
                <span>Pre-Workout</span>
              </Link>
              <Link to="/products/shaker" className="text-sm sm:text-base text-muted-foreground hover:text-primary flex items-center transition-colors" onClick={handleLinkClick}>
                <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4 mr-1" />
                <span>Shaker</span>
              </Link>
              <Link to="/products/chalk" className="text-sm sm:text-base text-muted-foreground hover:text-primary flex items-center transition-colors" onClick={handleLinkClick}>
                <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4 mr-1" />
                <span>Liquid Chalk</span>
              </Link>
              <Link to="/products/tennis-socks" className="text-sm sm:text-base text-muted-foreground hover:text-primary flex items-center transition-colors" onClick={handleLinkClick}>
                <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4 mr-1" />
                <span>Tennissokker (10-pakning)</span>
              </Link>
            </nav>
          </div>

          <div>
            <Link to="/" className="flex items-center mb-3 sm:mb-4" onClick={handleLinkClick}>
              <span className="font-orbit font-bold text-base sm:text-lg md:text-xl text-foreground">PEVEO <span className="text-primary">SUPPLEMENT STORE</span></span>
            </Link>
            <p className="text-muted-foreground mb-3 sm:mb-4 text-xs sm:text-sm">
              PEVEO tilbyr vitenskapelig baserte kosttilskudd og tilbehør for maksimal ytelse.
            </p>
            <div className="bg-primary/10 px-3 py-2 rounded-md border border-primary/20 mb-3 sm:mb-4">
              <p className="text-primary text-xs sm:text-sm font-semibold">
                🚚 Gratis frakt ved kjøp over 800 kr
              </p>
            </div>
            <div className="flex space-x-3 sm:space-x-4">
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors" onClick={handleLinkClick}>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors" onClick={handleLinkClick}>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-10 md:mt-12 pt-4 sm:pt-5 md:pt-6 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className="text-muted-foreground text-xs sm:text-sm text-center md:text-left">&copy; {new Date().getFullYear()} PEVEO SUPPLEMENT STORE. Alle rettigheter reservert.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
